export default {
  init() {
    // JavaScript to be fired on the home page

    $('.arc-plate-content--testimonials__slider').slick({
      adaptiveHeight : false,
      rows           : 0,
      prevArrow      : $('.slider-arrow--prev'),
      nextArrow      : $('.slider-arrow--next')
    });


    /**
     * Dynamic styling for testimonials, to avoid display issues when changing plate position.
     */
    if ($('.arc-plate-content--testimonials__slider') && $('.arc-plate-content--testimonials__slider').length) {
      $('.arc-plate-content--testimonials__slider').parent().parent().addClass('testimonials-container');
    }

    /**
     * Dynamic styling for testimonials, to avoid displaying issues when changing plate position
     */
    if ($('.arc-plate-content--services') && $('.arc-plate-content--services').length) {
      $('.arc-plate-content--services').parent().addClass('services-container');
    }

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    // Do not run JavaScript on Internet Explorer
    if (window.document.documentMode) {
      return;
    }

    /**
     *
     * Variables
     */

    // DOM Elements
    const frontPageSection   = document.getElementById('front-page-section');
    const arcPlateContainers = document.querySelectorAll('.arc-plate-container');
    const arcPlates          = document.querySelectorAll('#arc-plate');
    const arcPlatesContent   = document.querySelectorAll('.arc-plate-content-container');
    const backPlateBottom    = document.getElementById('back-plate-bottom');
    const backPlateContact   = document.querySelector('.back-plate-contact-form');
    const contactFormVideo   = document.getElementById('contact-form-video');
    const scrollIndicator    = $('#scroll-indicator');
    const getInTouchButton   = $('#get-in-touch-button');

    // Bound Variables
    this.timeout        = false;
    this.scrollCount    = 0;
    this.scrollMomentum = 0;
    this.touchY;
    this.indicatorTimer;

    /**
     *
     * Scroll Indicator
     */
    const setScrollTimeout = () => {
      clearTimeout(this.indicatorTimer);
      this.indicatorTimer = setTimeout(scrollTimeoutComplete, 1200);
    }

    const scrollTimeoutComplete = () => {
      clearTimeout(this.indicatorTimer);
      this.indicatorTimer = 0;

      scrollIndicator.css({
        'opacity'        : '1',
        'pointer-events' : 'all'
      })
    };

    const resetScrollIndicator = () => {
      const isLastSlide = this.scrollCount + 1 === arcPlateContainers.length;

      if (!!(this.indicatorTimer) && !isLastSlide) {
        setScrollTimeout();
      } else {
        scrollIndicator.css({
          'opacity'        : '0',
          'pointer-events' : 'none'
        })

        if (!isLastSlide)
          setScrollTimeout();
      }
    }

    $( document ).ready(setScrollTimeout)

    /**
     *
     * Scroll Animations
     */
    const incrementScroll = scrollDirection => {

      if (this.scrollCount < arcPlateContainers.length && scrollDirection === 'down')
        this.scrollCount++;

      if (this.scrollCount > 0 && scrollDirection === 'up')
        this.scrollCount--;

    }

    const runScrollAnimations = scrollDirection => {

      const lastContainer     = arcPlateContainers[this.scrollCount - 1];
      const currentContainer  = arcPlateContainers[this.scrollCount];
      const lastPlate         = arcPlates[this.scrollCount - 1];
      const currentPlate      = arcPlates[this.scrollCount];
      const currentPlateCount = (arcPlates.length - 1) - this.scrollCount;

      const setPlateColor = colorCount => {
        const plateColors = [ 'blue', 'magenta', 'orange', 'green', 'grey' ];

        let plateColor = plateColors[0];
        switch (colorCount) {
          case 0 : plateColor = plateColors[0]; break;
          case 1 : plateColor = plateColors[1]; break;
          case 2 : plateColor = plateColors[2]; break;
          case 3 : plateColor = plateColors[3]; break;
          case 4 : plateColor = plateColors[4]; break;
          default: plateColor = plateColors[plateColors.length - 1]; break;
        }

        frontPageSection.classList.forEach(className => {
          if (RegExp('front-page-section--.*').test(className)) {
            frontPageSection.classList.remove(className);
            frontPageSection.classList.add(`front-page-section--${plateColor}`);
          }
        })
      }

      // Animations for Down Scrolling
      if (scrollDirection === 'down' && this.scrollCount < arcPlateContainers.length) {

        setPlateColor(this.scrollCount + 1);

        currentContainer.classList.add('arc-plate-container--hidden');
        setTimeout(() => {
          currentPlate.classList.add('arc-plate--hidden');
        }, 900)

        backPlateBottom.classList.remove(`front-page-section__back-plate__bottom--${currentPlateCount + 1}`);
        backPlateBottom.classList.add(`front-page-section__back-plate__bottom--${currentPlateCount}`);

        // Toggle Contact Form
        if (this.scrollCount + 1 >= arcPlates.length && backPlateContact.classList.contains('back-plate-contact-form--hidden')) {
          backPlateContact.classList.remove('back-plate-contact-form--hidden');
          contactFormVideo.play();
        }

        for( let i = this.scrollCount + 1; i <= arcPlates.length; i++ ) {
          const activeContainer = arcPlateContainers[i];
          const activePlate     = arcPlates[i];
          const activeContent   = arcPlatesContent[i];

          if (activePlate) {
            const dataPosition = parseInt(activePlate.getAttribute('data-position'));

            activeContainer.classList.remove(`arc-plate-container--${dataPosition}`);
            activeContainer.classList.add(`arc-plate-container--${dataPosition - 1}`);
            activeContainer.setAttribute('data-position', dataPosition - 1);

            activePlate.classList.remove(`arc-plate--${dataPosition}`);
            activePlate.classList.add(`arc-plate--${dataPosition - 1}`);
            activePlate.setAttribute('data-position', dataPosition - 1);

            activeContent.classList.remove(`arc-plate-content-container--${dataPosition}`);
            activeContent.classList.add(`arc-plate-content-container--${dataPosition - 1}`);
            activeContent.setAttribute('data-position', dataPosition - 1);

          }
        }
      }

      // Animations for Up Scrolling
      if (scrollDirection === 'up' && this.scrollCount >= 0 && lastContainer) {

        setPlateColor(this.scrollCount - 1);

        lastContainer.classList.remove('arc-plate-container--hidden');
        lastPlate.classList.remove('arc-plate--hidden');

        backPlateBottom.classList.remove(`front-page-section__back-plate__bottom--${currentPlateCount + 1}`);
        backPlateBottom.classList.add(`front-page-section__back-plate__bottom--${currentPlateCount + 2}`);

        // Toggle Contact Form
        if (!backPlateContact.classList.contains('back-plate-contact-form--hidden')) {
          backPlateContact.classList.add('back-plate-contact-form--hidden');
          contactFormVideo.pause();
          setTimeout(() => {
            contactFormVideo.currentTime = 0;
          }, 1000)
        }

        for( let i = this.scrollCount; i <= arcPlates.length; i++ ) {
          const activeContainer = arcPlateContainers[i];
          const activePlate     = arcPlates[i];
          const activeContent   = arcPlatesContent[i];

          if (activePlate) {
            const dataPosition = parseInt(activePlate.getAttribute('data-position'));

            activeContainer.classList.remove(`arc-plate-container--${dataPosition}`);
            activeContainer.classList.add(`arc-plate-container--${dataPosition + 1}`);
            activeContainer.setAttribute('data-position', dataPosition + 1);

            activePlate.classList.remove(`arc-plate--${dataPosition}`);
            activePlate.classList.add(`arc-plate--${dataPosition + 1}`);
            activePlate.setAttribute('data-position', dataPosition + 1);

            activeContent.classList.remove(`arc-plate-content-container--${dataPosition}`);
            activeContent.classList.add(`arc-plate-content-container--${dataPosition + 1}`);
            activeContent.setAttribute('data-position', dataPosition + 1);

          }
        }
      }

    }

    // Detect Touch Direction
    const detectTouchDirection = e => {
      if (e.type === 'touchstart') this.touchY = e.changedTouches[0].clientY;

      if (e.type === 'touchend' && this.touchY !== e.changedTouches[0].clientY)
        return ( this.touchY - e.changedTouches[0].clientY < 0)
          ? 'up'
          : 'down';
    }

    const initiateScroll = (scrollDirection, timeout=1300) => {
      resetScrollIndicator();
      runScrollAnimations(scrollDirection);
      incrementScroll(scrollDirection);

      this.timeout = true;
      setTimeout(() => this.timeout = false, timeout);
    }

    // Event Handler for Touch Scrolling
    const handleTouchScroll = e => {
      const topOffset      = Math.round(window.scrollY),
            documentHeight = document.body.offsetHeight,
            windowHeight   = window.innerHeight,
            documentOffset = topOffset + windowHeight;

      const touchDirection = detectTouchDirection(e);
      const timeout        = 600;

      if (!this.timeout) {

        if ( touchDirection === 'up' ) {
          initiateScroll('up', timeout);
        }
        if ( touchDirection === 'down' && documentOffset >= documentHeight) {
          initiateScroll('down', timeout);
        }

      }

    }

    // Event Handler for Mouse and Trackpad Scrolling
    const handleWheelScroll = e => {
      if (!this.timeout) {
        const scrollDirection = ( e.deltaY < 0 ) ? 'up' : 'down';

        initiateScroll(scrollDirection, 1300)
      }
    }

    // Event Listeners
    document.addEventListener('touchstart', detectTouchDirection);
    document.addEventListener('touchend', handleTouchScroll);
    document.addEventListener('wheel', handleWheelScroll);

    scrollIndicator.click(() => initiateScroll('down', 1300) );
    getInTouchButton.click(() => initiateScroll('down', 1300) );

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js